<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import ErrorMessage from "../../components/error-message";
import VueSweetalert2 from "vue-sweetalert2";
import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
  },
  data() {
    return {
      errorMessage: "",
      title: "API Vendor Create",
      items: [
        {
          text: "API Vendor",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
        visible:false,
        message:"",
      form: {
        api_provider: "",
        api_name_tag: "",
        username: "",
        password: "",
        password_confirmation: "",
        target_branch: "",
        ipcc: "",
          ipcc_country_code:"",
        balance: "",
        track_api_balance: "",
        is_search_default: "",
        is_direct_ticket_enabled: "",
          is_active:"",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      api_provider: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(100),
      },
      api_name_tag: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(100),
      },
      username: {
        required,
      },
      password: {
        required,
      },
      password_confirmation: {
        required,
      },
      target_branch: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(100),
      },
      ipcc: {
        required,
        minLength: minLength(2),
        maxLength: maxLength(100),
      },
        ipcc_country_code: {
            required,
        },
      balance: {
        required,
      },
      track_api_balance: {
        required,
      },
      is_search_default: {
        required,
      },
      is_direct_ticket_enabled: {
        required,
      },
        is_active:{
          required,
        }
    },
  },
  methods: {
      onClose(){
          this.visible=false;
      },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/vendor/create", {
          api_provider: this.form.api_provider,
          api_name_tag: this.form.api_name_tag,
          username: this.form.username,
          password: this.form.password,
          password_confirmation: this.form.password_confirmation,
          target_branch: this.form.target_branch,
          ipcc: this.form.ipcc,
            ipcc_country_code:this.form.ipcc_country_code,
          balance: this.form.balance,
          track_api_balance: this.form.track_api_balance,
          is_search_default: this.form.is_search_default,
          is_direct_ticket_enabled: this.form.is_direct_ticket_enabled,
            is_active:this.form.is_active,
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.vendorEntryForm.reset();
            this.$swal("Good job!", "Api Vendor Created", "success");
            this.$router.push({ name: "api_vendor_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
          console.log(obj);
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
            <div v-if="errors" class="font-bold mb-4 ">
              <div v-for="(v, k) in errors" :key="k">
                <p v-for="error in v" :key="error" class="text-sm">
                  {{ error }}
                </p>
              </div>
            </div>
            <b-form class="needs-validation" ref="vendorEntryForm" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="api_provider">API Provider</label>
                    <input
                      id="api_provider"
                      v-model="form.api_provider"
                      name="api_provider"
                      type="text"
                      class="form-control"
                      placeholder="Type API Provider"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.api_provider.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.api_provider.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.api_provider.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label class="required" for="api_name_tag">API Name Tag</label>
                    <input
                      id="api_name_tag"
                      v-model="form.api_name_tag"
                      name="api_name_tag"
                      type="text"
                      class="form-control"
                      placeholder="Type API Name Tag"
                      value
                      :class="{ 'is-invalid': submitted && $v.form.api_name_tag.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.api_name_tag.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.api_name_tag.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="username">User Name</label>
                    <input
                      id="username"
                      v-model="form.username"
                      name="username"
                      type="text"
                      class="form-control"
                      placeholder="Type User Name"
                      value
                      :class="{ 'is-invalid-no': submitted && $v.form.username.$error }"
                    />
<!--                    <div-->
<!--                      v-if="submitted && $v.form.username.$error"-->
<!--                      class="invalid-feedback"-->
<!--                    >-->
<!--                      <span v-if="!$v.form.username.required">This value is required.</span>-->
<!--                    </div>-->
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="form-group">
                    <label for="password">Passowrd</label>
                    <input
                      id="password"
                      v-model="form.password"
                      name="password"
                      type="password"
                      class="form-control"
                      placeholder="Type Passowrd"
                      value
                      :class="{ 'is-invalid-no': submitted && $v.form.password.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.password.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.password.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="password_confirmation">Confirm Password</label>
                    <input
                      id="password_confirmation"
                      v-model="form.password_confirmation"
                      name="password_confirmation"
                      type="password"
                      class="form-control"
                      placeholder="Confirm Password"
                      value
                      :class="{ 'is-invalid-no': submitted && $v.form.password_confirmation.$error }"
                    />
                    <div
                      v-if="submitted && $v.form.password_confirmation.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.password_confirmation.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="target_branch">Target Branch</label>
                    <input
                      id="target_branch"
                      v-model="form.target_branch"
                      name="target_branch"
                      type="text"
                      class="form-control"
                      placeholder="Type Target Branch"
                      value
                      :class="{ 'is-invalid-no': submitted && $v.form.target_branch.$error }"
                    />
<!--                    <div-->
<!--                      v-if="submitted && $v.form.target_branch.$error"-->
<!--                      class="invalid-feedback"-->
<!--                    >-->
<!--                      <span v-if="!$v.form.target_branch.required">This value is required.</span>-->
<!--                    </div>-->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="ipcc">IPCC</label>
                    <input
                      id="ipcc"
                      v-model="form.ipcc"
                      name="ipcc"
                      type="text"
                      class="form-control"
                      placeholder="Type IPCC"
                      value
                      :class="{ 'is-invalid-no': submitted && $v.form.ipcc.$error }"
                    />
<!--                    <div-->
<!--                      v-if="submitted && $v.form.ipcc.$error"-->
<!--                      class="invalid-feedback"-->
<!--                    >-->
<!--                      <span v-if="!$v.form.ipcc.required">This value is required.</span>-->
<!--                    </div>-->
                  </div>
                </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label for="ipcc_country_code">IPCC Country Code</label>
                          <input
                              id="ipcc_country_code"
                              v-model="form.ipcc_country_code"
                              name="ipcc_country_code"
                              type="text"
                              class="form-control"
                              placeholder="Type IPCC Country Code"
                              value
                              :class="{ 'is-invalid-no': submitted && $v.form.ipcc.$error }"
                          />
                          <!--                    <div-->
                          <!--                      v-if="submitted && $v.form.ipcc.$error"-->
                          <!--                      class="invalid-feedback"-->
                          <!--                    >-->
                          <!--                      <span v-if="!$v.form.ipcc.required">This value is required.</span>-->
                          <!--                    </div>-->
                      </div>
                  </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="balance">Balance</label>
                    <input
                      id="balance"
                      v-model="form.balance"
                      name="balance"
                      type="number"
                      class="form-control"
                      placeholder="Type Balance"
                      value
                      :class="{ 'is-invalid-no': submitted && $v.form.balance.$error }"
                    />
<!--                    <div-->
<!--                      v-if="submitted && $v.form.balance.$error"-->
<!--                      class="invalid-feedback"-->
<!--                    >-->
<!--                      <span v-if="!$v.form.balance.required">This value is required.</span>-->
<!--                    </div>-->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="track_api_balance">Track Api Balance</label>
                    <select
                      id="track_api_balance"
                      name="track_api_balance"
                      v-model="form.track_api_balance"
                      class="form-control"
                      :class="{ 'is-invalid-no': submitted && $v.form.track_api_balance.$error }">
                        <option value="" disabled style="display:none" selected>Select Track Api Balance</option>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </select>
<!--                    <div-->
<!--                      v-if="submitted && $v.form.track_api_balance.$error"-->
<!--                      class="invalid-feedback"-->
<!--                    >-->
<!--                      <span v-if="!$v.form.track_api_balance.required">This value is required.</span>-->
<!--                    </div>-->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="is_search_default">Search Default</label>
                    <select
                      id="is_search_default"
                      name="is_search_default"
                      v-model="form.is_search_default"
                      class="form-control"
                      :class="{ 'is-invalid-no': submitted && $v.form.is_search_default.$error }">
                        <option value="" disabled style="display:none" selected>Select Search Default</option>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </select>
<!--                    <div-->
<!--                      v-if="submitted && $v.form.is_search_default.$error"-->
<!--                      class="invalid-feedback"-->
<!--                    >-->
<!--                      <span v-if="!$v.form.is_search_default.required">This value is required.</span>-->
<!--                    </div>-->
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label for="is_direct_ticket_enabled">Direct Ticket Enabled</label>
                    <select
                      id="is_direct_ticket_enabled"
                      name="is_direct_ticket_enabled"
                      v-model="form.is_direct_ticket_enabled"
                      class="form-control"
                      :class="{ 'is-invalid-no': submitted && $v.form.is_direct_ticket_enabled.$error }">
                        <option value="" disabled style="display:none" selected>Select Direct Ticket Enabled</option>
                      <option value='1'>Yes</option>
                      <option value='0'>No</option>
                    </select>
<!--                    <div-->
<!--                      v-if="submitted && $v.form.is_direct_ticket_enabled.$error"-->
<!--                      class="invalid-feedback"-->
<!--                    >-->
<!--                      <span v-if="!$v.form.is_direct_ticket_enabled.required">This value is required.</span>-->
<!--                    </div>-->
                  </div>
                </div>
                  <div class="col-md-6">
                      <div class="form-group">
                          <label for="is_active">Active</label>
                          <select
                              id="is_active"
                              name="is_active"
                              v-model="form.is_active"
                              class="form-control"
                              :class="{ 'is-invalid-no': submitted && $v.form.is_active.$error }">
                              <option value="" disabled style="display:none" selected>Select Active</option>
                              <option value='1'>Yes</option>
                              <option value='0'>No</option>
                          </select>
<!--                          <div-->
<!--                              v-if="submitted && $v.form.is_active.$error"-->
<!--                              class="invalid-feedback"-->
<!--                          >-->
<!--                              <span v-if="!$v.form.is_active.required">This value is required.</span>-->
<!--                          </div>-->
                      </div>
                  </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
